export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5563.fd07f7d4.jpg";